exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".subjective[data-v-4a8c2c79]::-webkit-input-placeholder {\n  font-style: italic;\n  color: lightgray;\n}\n.subjective[data-v-4a8c2c79]::-moz-placeholder {\n  font-style: italic;\n  color: lightgray;\n}\n.subjective[data-v-4a8c2c79]:-ms-input-placeholder {\n  font-style: italic;\n  color: lightgray;\n}\n.subjective[data-v-4a8c2c79]::-ms-input-placeholder {\n  font-style: italic;\n  color: lightgray;\n}\n.subjective[data-v-4a8c2c79]::placeholder {\n  font-style: italic;\n  color: lightgray;\n}\n#signature[data-v-4a8c2c79] {\n  border: 1px solid lightgray;\n}", ""]);

// exports
